import * as React from 'react';
import PropTypes from 'prop-types';

class BiddingRound extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bids: new Array(this.props.players.length).fill(null),
            submitDisabled: true,
            message: 'Faza licitare'
        };

        this.handleChangePlayerBid = this.handleChangePlayerBid.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChangePlayerBid(player, event) {
        let bids = this.state.bids.slice();
        bids[player] = parseInt(event.target.value, 10);

        this.setState({ bids });
        this.checkBids(bids);
    }

    checkBids(bids) {
        let message = null;
        let submitDisabled = true;

        let bidsExceptLastPlayer = bids
            .slice(0, -1)
            .filter((el) => el !== null)
            .length;

        if (bidsExceptLastPlayer < this.props.players.length - 1) {
            // Not all players (except the last) submitted their bid
            message = 'Asteptam toti userii sa liciteze.';
        } else {
            let bidsSum = 0;

            // don't add last player's bid
            for (let i = 0; i < this.props.players.length - 1; i++) {
                if (bids[i] !== null) {
                    bidsSum += bids[i];
                }
            }

            let notAllowed = null;
            if (bidsSum <= this.props.cardsCount) {
                notAllowed = this.props.cardsCount - bidsSum;
                message = 'Ultimul jucator nu are voie sa liciteze ' + notAllowed + '.';
                let synthesis = window.speechSynthesis;
                let utterance = new SpeechSynthesisUtterance('Last player not allowed ' + notAllowed);

                synthesis.speak(utterance);

            } else {
                message = 'Ultimul jucator poate licita orice.';
                let synthesis = window.speechSynthesis;
                let utterance = new SpeechSynthesisUtterance('Last player can bid anything');

                synthesis.speak(utterance);
            }

            let lastPlayerBid = bids[this.props.players.length - 1];
            if (lastPlayerBid !== null && lastPlayerBid !== notAllowed) {
                submitDisabled = false;
            }
        }

        this.setState({ message, submitDisabled });
    }

    handleSubmit() {
        this.props.onSubmit(this.state.bids);
    }

    renderBidOptions(playerIndex) {
        let options = [];
        for (let i = 0; i <= this.props.cardsCount; i++) {
            options.push(i);
        }

        return (
            options.map(i => {
                return (
                    <div className="form-check form-check-inline" key={ i }>
                        <input key={ i } className="form-check-input"
                               type="radio"
                               name={ "player" + playerIndex }
                               id={ "inlineRadio" + playerIndex }
                               value={ i }
                               onChange={ (e) => this.handleChangePlayerBid(playerIndex, e) }/>{ i }
                    </div>
                );
            })
        )
    }

    render() {
        return (
            <div><strong>Licitație</strong><br /><br />
                { this.props.players.map((player, index) => {
                    return (
                        <div className="d-block" key={ index }>
                            { player.name }:
                            <br/>
                            { this.renderBidOptions(index) }
                            <br/><br/>
                        </div>
                    )
                }) }

                <div className="text-danger mb-3 h6">
                    { this.state.message }
                </div>

                <button
                    className="btn btn-sm btn-success"
                    onClick={ this.handleSubmit }
                    disabled={ this.state.submitDisabled }
                >
                    Gata licitatia
                </button>
            </div>
        );
    }
}

BiddingRound.propTypes = {
    cardsCount: PropTypes.number.isRequired,
    players: PropTypes.arrayOf(PropTypes.object).isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default BiddingRound;



// WEBPACK FOOTER //
// ./src/components/BiddingRound.js